import type { RouteRecordRaw } from 'vue-router';
import { LazyComponent } from '@/models/LazyComponent';

const CheckoutView: LazyComponent = () => import('./views/CheckoutView.vue');

const routes: RouteRecordRaw[] = [
  {
    name: 'checkout',
    path: '/divida/:api/:dividaId/checkout/:ofertaId?',
    component: CheckoutView,
    props: true,
    meta: {
      scrollToTop: true,
    },
  },
];

export default routes;
